module.exports = __webpack_public_path__ + "media/images/sp/articles/area_map-9af5a1bd2363aca588928bd22b27cb0b.webp";